import { combineReducers } from "redux";
import leadsReducer from "./leads";
import createLeadReducer from "./newLead";
import needAnalysisReducer from "./needAnalysis";
import proposalFormFillingReducer from "./proposalFormReducer";
import addressReducer from "./address";
import loginReducer from "./auth";
import homeReducer from "./home";
import activitiesReducer from "./home";
import kpiDashboardReducer from "./kpiDashboard";
import renewalReducer from "./renewals";
import productReducer from "./product";
import agentReducer from "./agentMicroSite";
import advisorReducer from "./advisor";
import applicationReducer from "./applicationreducer";
import fetchproductsReducer from "./fetchallproducts";
import proposalDetailsReducer from "./proposalAgentDetails";
import biReducer from "./bi";
import einsuranceReducer from "./einsurance";
import detailsOfPlansReducer from "./detailsOfPlan";
import aboutCustomerReducer from "./aboutCustomer";
import financialDetailsReducer from "./financialDetails";
import declarationReducer from "./declaration";
import nominationDetailsReducer from "./nominationDetails";
import paymentReducer from "./payment";
import proposaDetails from "./proposalDetails";
import previousPolicyDetailReducer from "./previousPolicyDetails";
import healthDetailsReducer from "./healthDetails";
// import BICardReducer from './BICardReducer';
// import activitiesReducer from './home'
import historyReducer from "./history";
import EsirForm from "./EsirForm";
import ENACHStatus from "./enach";
import configureStore from "../CreateStore";
import liEkycReducer from "./liEkycDetails";
import subSourceReducer from "./subSource";
import gapCalculator from "./gapCalculator";
import enachRules from "./enachRulesData";
import iibCount from "./iibCount";
// import pendencyReducer from './penc'
import * as actionTypes from "../actions/actionTypes";
import athenaPaymentReducer from "./athenaPayment";

export default () => {
  const rootReducer = combineReducers({
    leads: leadsReducer,
    newLead: createLeadReducer,
    address: addressReducer,
    login: loginReducer,
    home: homeReducer,
    activities: activitiesReducer,
    kpiDashboard: kpiDashboardReducer,
    renewals: renewalReducer,
    history: historyReducer,
    product: productReducer,
    agent: agentReducer,
    advisor: advisorReducer,
    applicationReducer,
    proposalDetails: proposalDetailsReducer,
    needAnalysis: needAnalysisReducer,
    proposalFormFilling: proposalFormFillingReducer,
    productslist: fetchproductsReducer,
    bi: biReducer,
    einsurance: einsuranceReducer,
    detailsOfPlans: detailsOfPlansReducer,
    aboutCustomer: aboutCustomerReducer,
    financialDetails: financialDetailsReducer,
    healthDetails: healthDetailsReducer,
    previousPolicyDetail: previousPolicyDetailReducer,
    declaration: declarationReducer,
    nominationDetails: nominationDetailsReducer,
    payments: paymentReducer,
    proposaDetails: proposaDetails,
    esir: EsirForm,
    eNACH: ENACHStatus,
    liekycReducer: liEkycReducer,
    gapCalculator: gapCalculator,
    subSource: subSourceReducer,
    enachRulesData: enachRules,
    iibCount: iibCount,
    athenaPayment: athenaPaymentReducer,
    // BICardReducer,
    // pendencies:pendencyReducer
  });

  const reducerProxy = (state, action) => {
    if (action.type === actionTypes.AUTH_LOGOUT_SUCCESS) {
      return rootReducer(undefined, action);
    }
    // //console.log("hh=========666666666666666", action);
    return rootReducer(state, action);
  };

  return configureStore(reducerProxy);
};

// export default rootReducer;
